import {SelectItemProps} from '@radix-ui/react-select'
import {HiCheck, HiChevronDown} from 'react-icons/hi2'
import {useNavigate} from '@tanstack/react-router'
import * as Select from '@radix-ui/react-select'
import {forwardRef, useCallback} from 'react'
import {useTranslations} from 'use-intl'
import clsx from 'clsx'
import useLocaleParams from '~/hooks/useLocaleParams'

const LanguageSelector = () => {
    const t = useTranslations('languageSelector')
    const navigate = useNavigate()
    const {lang} = useLocaleParams()

    const changeLanguage = useCallback(
        (newLang: string) => {
            void navigate({
                to: '/$lang',
                params: {
                    lang: newLang,
                },
                reloadDocument: true,
            })
        },
        [navigate]
    )

    return (
        <Select.Root defaultValue={lang} onValueChange={changeLanguage}>
            <Select.Trigger
                className="px-4 py-3 flex justify-center items-center gap-2 leading-4 border border-white rounded"
                aria-label={t('title')}
            >
                <Select.Value />
                <Select.Icon className="size-5">
                    <HiChevronDown className="size-full" />
                </Select.Icon>
            </Select.Trigger>
            <Select.Portal>
                <Select.Content
                    className="overflow-hidden rounded-md shadow bg-black/80 backdrop-blur-xl transform-gpu"
                    position="popper"
                    side="top"
                    sideOffset={6}
                >
                    <Select.Viewport className="p-1.5">
                        <Select.Group>
                            <SelectItem value="de">{t('options.de')}</SelectItem>
                            <SelectItem value="en">{t('options.en')}</SelectItem>
                        </Select.Group>
                    </Select.Viewport>
                </Select.Content>
            </Select.Portal>
        </Select.Root>
    )
}

const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
    ({children, className, value, ...props}, forwardedRef) => {
        return (
            <Select.Item
                className={clsx(
                    'relative flex items-center gap-2 outline-none cursor-pointer pl-8 pr-6 py-2',
                    className
                )}
                value={value}
                {...props}
                ref={forwardedRef}
            >
                <Select.ItemText>{children}</Select.ItemText>
                <Select.ItemIndicator className="absolute left-1 inline-flex size-4 items-center justify-center">
                    <HiCheck />
                </Select.ItemIndicator>
            </Select.Item>
        )
    }
)

export default LanguageSelector
